module.exports = __webpack_public_path__ + "static/media/card3_6.36102371.png";